var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{staticClass:"item",attrs:{"content":_vm.processRatingCompanyNumbers(),"placement":"right-end"}},[_c('div',[_vm._v(_vm._s(_vm.processCompanyNumber()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }